import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CoreComponent } from "./core/core.component";
import { CollectionsComponent } from "./pages/collections/collections.component";
import { DownloadsComponent } from "./pages/downloads/downloads.component";
import { ExclusiveCollectionsComponent } from "./pages/exclusive-collections/exclusive-collections.component";
import { FavoritesComponent } from "./pages/favorites/favorites.component";
import { FeaturedCollectionsComponent } from "./pages/featured-collections/featured-collections.component";
import { HomeComponent } from "./pages/home/home.component";
import { IllustrationCollectionComponent } from "./pages/illustration-collection/illustration-collection.component";
import { IllustrationComponent } from "./pages/illustration/illustration.component";
import { LatestCollectionsComponent } from "./pages/latest-collections/latest-collections.component";
import { PopularCollectionsComponent } from "./pages/popular-collections/popular-collections.component";
import { PrivacyComponent } from "./pages/privacy/privacy.component";
import { ProfileComponent } from "./pages/profile/profile.component";
import { SearchComponent } from "./pages/search/search.component";
import { SupportComponent } from "./pages/support/support.component";
import { TermsComponent } from "./pages/terms/terms.component";
import { OtherCollectionsComponent } from "./pages/other-collections/other-collections.component";

import { AuthGuard } from "../auth.guard";
import { IllustrationResolver } from "./pages/illustration/illustration.resolver";
import { SsrPreloadGuard } from "src/ssr-preload.guard";
import { PricingComponent } from "./pages/pricing/pricing.component";
import { SubscriptionComponent } from "./pages/subscription/subscription.component";
import { IllustrationCollectionResolver } from "./pages/illustration-collection/illustration-collection.resolver";
import { HomeResolver } from "./pages/home/home.resolver";
import { CollectionsResolver } from "./pages/collections/collections.resolver";
import { RefundComponent } from "./pages/refund/refund.component";
import { ShippingComponent } from "./pages/shipping/shipping.component";
import { ContactComponent } from "./pages/contact/contact.component";
import { PricingResolver } from "./pages/pricing/pricing.resolver";
import { ContactResolver } from "./pages/contact/contact.resolver";
import { SupportResolver } from "./pages/support/support.resolver";
import { TermsResolver } from "./pages/terms/terms.resolver";
import { RefundResolver } from "./pages/refund/refund.resolver";
import { PrivacyResolver } from "./pages/privacy/privacy.resolver";
import { AIImagesComponent } from "./pages/ai/ai-images/ai-images.component";
import { AIImageResolver } from "./pages/ai/ai-images/aiimage.resolver";
import { AIIllustrationCollectionComponent } from "./pages/ai/ai-image-collection/ai-image-collection.component";
import { AIIllustrationCollectionResolver } from "./pages/ai/ai-image-collection/ai-image-collection.resolver";
import { AIOtherCollectionsComponent } from "./pages/ai/ai-other-collections/ai-other-collections.component";
import { AIFeaturedCollectionsComponent } from "./pages/ai/ai-featured-collections/ai-featured-collections.component";
import { AILatestCollectionsComponent } from "./pages/ai/ai-latest-collections/ai-latest-collections.component";
import { AIPopularCollectionsComponent } from "./pages/ai/ai-popular-collections/ai-popular-collections.component";
import { AIExclusiveCollectionsComponent } from "./pages/ai/ai-exclusive-collections/ai-exclusive-collections.component";
import { AIIllustrationComponent } from "./pages/ai/ai-image/ai-image.component";
import { AIIllustrationResolver } from "./pages/ai/ai-image/ai-image.resolver";

const routes: Routes = [
  {
    path: "",
    component: CoreComponent,
    children: [
      {
        path: "",
        component: HomeComponent,
        resolve: { illustration: HomeResolver },
        canActivate: [SsrPreloadGuard],
      },
      {
        path: "search",
        component: SearchComponent,
      },
      {
        path: "search/:id",
        component: SearchComponent,
      },
      {
        path: "search/:searchkey/:id",
        component: SearchComponent,
      },
      {
        path: "search/:searchkey/:id/:cate",
        component: SearchComponent,
      },
      {
        path: "illustration",
        component: IllustrationComponent,
        resolve: { illustration: IllustrationResolver },
        canActivate: [SsrPreloadGuard],
      },
      {
        path: "illustration/:slug",
        component: IllustrationComponent,
        resolve: { illustration: IllustrationResolver },
        canActivate: [SsrPreloadGuard],
      },
      {
        path: "illustration/:title",
        component: IllustrationComponent,
        resolve: { illustration: IllustrationResolver },
        canActivate: [SsrPreloadGuard],
      },

      {
        path: "ai-images",
        component: AIImagesComponent,
        resolve: { aiimage: AIImageResolver },
        canActivate: [SsrPreloadGuard],
      },
      {
        path: "ai-images/:id",
        component: AIImagesComponent,
        resolve: { aiimage: AIImageResolver },
        canActivate: [SsrPreloadGuard],
      },

      {
        path: "collections",
        component: CollectionsComponent,
        resolve: { illustration: CollectionsResolver },
        canActivate: [SsrPreloadGuard],
      },
      {
        path: "illustration-collection",
        component: IllustrationCollectionComponent,
        resolve: { illustration: IllustrationCollectionResolver },
        canActivate: [SsrPreloadGuard],
      },
      {
        path: "illustration-collection/:slug",
        component: IllustrationCollectionComponent,
        resolve: { illustration: IllustrationCollectionResolver },
        canActivate: [SsrPreloadGuard],
      },
      {
        path: "ai-image",
        component: AIIllustrationComponent,
        resolve: { illustration: AIIllustrationResolver },
        canActivate: [SsrPreloadGuard],
      },
      {
        path: "ai-image/:slug",
        component: AIIllustrationComponent,
        resolve: { illustration: AIIllustrationResolver },
        canActivate: [SsrPreloadGuard],
      },
      {
        path: "ai-image/:title",
        component: AIIllustrationComponent,
        resolve: { illustration: AIIllustrationResolver },
        canActivate: [SsrPreloadGuard],
      },
      {
        path: "ai-image-collection",
        component: AIIllustrationCollectionComponent,
        resolve: { illustration: AIIllustrationCollectionResolver },
        canActivate: [SsrPreloadGuard],
      },
      {
        path: "ai-image-collection/:slug",
        component: AIIllustrationCollectionComponent,
        resolve: { illustration: AIIllustrationCollectionResolver },
        canActivate: [SsrPreloadGuard],
      },
      // {
      //   path: 'illustration-collection/:id/:cate', component: IllustrationCollectionComponent
      // },
      {
        path: "exclusive-collections",
        component: ExclusiveCollectionsComponent,
        data: { title: "Exclusive Collections" },
      },
      {
        path: "popular-collections",
        component: PopularCollectionsComponent,
        data: { title: "Popular Collections" },
      },
      {
        path: "latest-collections",
        component: LatestCollectionsComponent,
        data: { title: "Latest Collections" },
      },
      {
        path: "featured-collections",
        component: FeaturedCollectionsComponent,
        data: { title: "Featured Collections" },
      },
      {
        path: "other-collections",
        component: OtherCollectionsComponent,
        data: { title: "Other Collections" },
      },
      {
        path: "ai-exclusive-collections",
        component: AIExclusiveCollectionsComponent,
        data: { title: "Exclusive AI Collections" },
      },
      {
        path: "ai-popular-collections",
        component: AIPopularCollectionsComponent,
        data: { title: "Popular AI Collections" },
      },
      {
        path: "ai-latest-collections",
        component: AILatestCollectionsComponent,
        data: { title: "Latest AI Collections" },
      },
      {
        path: "ai-featured-collections",
        component: AIFeaturedCollectionsComponent,
        data: { title: "Featured AI Collections" },
      },
      {
        path: "ai-other-collections",
        component: AIOtherCollectionsComponent,
        data: { title: "Other AI Collections" },
      },
      {
        path: "profile",
        component: ProfileComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "downloads",
        component: DownloadsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "favorites",
        component: FavoritesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "subscription",
        component: SubscriptionComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "support",
        component: SupportComponent,
        resolve: { support: SupportResolver },
      },
      {
        path: "pricing",
        component: PricingComponent,
        resolve: { pricing: PricingResolver },
      },
      {
        path: "terms",
        component: TermsComponent,
        resolve: { terms: TermsResolver },
      },
      {
        path: "privacy",
        component: PrivacyComponent,
        resolve: { privacy: PrivacyResolver },
      },
      {
        path: "refund",
        component: RefundComponent,
        resolve: { refund: RefundResolver },
      },
      {
        path: "shipping",
        component: ShippingComponent,
      },
      {
        path: "contact",
        component: ContactComponent,
        resolve: { contact: ContactResolver },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LayoutRoutingModule {}
